const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

/**
 * Fetches the button ID associated with a specific link
 * @param {string} linkId - The ID of the link to fetch the button for
 * @returns {Promise<string>} - Promise resolving to the button ID
 */
export const getButtonId = async (linkId) => {
  try {
    const response = await fetch(`${apiBaseUrl}/link-to-button/${linkId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch button ID: ${response.status}`);
    }

    const data = await response.json();

    const { buttonId } = data;
    return buttonId;
  } catch (error) {
    console.error('Error fetching button:', error);
    throw error;
  }
};
